import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PlayfulBlobs from './PlayfulBlobs';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // Allow rendering in tests that do not mount a ThemeProvider.
    padding:
      theme && typeof (theme as any).spacing === 'function'
        ? (theme as any).spacing(2)
        : 16,
  },
}));

export default function SmoothLoadingIndicator(props: { size?: number }) {
  const classes = useStyles(props);
  return (
    <div className={classes.root} role="progressbar">
      <PlayfulBlobs size={props.size || 180} animated />
    </div>
  );
}
